<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i><strong>Liste des consignes</strong>
      </b-card-header>
      <b-card-body>
        <v-client-table :columns="columns" :data="data" :options="options">
          <div v-if="props.row.created_at" slot="created_at" slot-scope="props" class="slot-date">
            <span class="badge badge-success p-2">{{ formatDateHeure(props.row.created_at) }}</span>
          </div>
          <div v-if="props.row.updated_at" slot="updated_at" slot-scope="props" class="slot-date">
            <span class="badge badge-success p-2">{{ formatDateHeure(props.row.updated_at) }}</span>
          </div>
          <div v-if="props.row.date_debut" slot="date_debut" slot-scope="props" class="slot-date">
            <span class="badge badge-success p-2">{{ formatDate(props.row.date_debut) }}</span>
          </div>
          <div v-if="props.row.date_fin" slot="date_fin" slot-scope="props" class="slot-date">
            <span class="badge badge-success p-2">{{ formatDate(props.row.date_fin) }}</span>
          </div>
           <div slot="action" slot-scope="props">
            <i class="fa fa-pencil mr-2 text-primary clickable" @click="edit(props.row.id)"></i>
            <i class="fa fa-trash clickable text-danger" @click.prevent="destroy(props.row.id)"></i>
          </div>
        </v-client-table>
      </b-card-body>

      <div slot="footer">
        <b-button v-if="canExtract(rules.EXTRACT_CONSIGNES_PRODUITS)" type="button" size="md" variant="success">
          <i class="fa fa-file-excel-o"></i>&nbsp;<a @click="downloadConsignesProduit" class="bleu_clair">Exporter en Excel</a><br>
        </b-button>
        <b-button type="button" @click="add" class="pull-right" size="md" variant="primary">
          <i class="fa fa-plus"></i> Ajouter une consigne
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "@/utils/auth";
  import { formatDateTime } from "@/utils/communHelper";
  import { isEmpty, downloadFile } from "@/utils/fileHelper";
  import { espaceGestionRules, hasRule } from "@/utils/rulesHelper";
  import moment from 'moment';

  export default {
    name: "List",
    data() {
      return {
        columns: ['created_at', 'famille_produit.libelle', 'commentaire', 'date_debut', 'date_fin', 'updated_at', 'action'],
        data: [],
        options: {
          headings: {
            'created_at': 'Date de création',
            'famille_produit.libelle': 'Famille produit',
            'date_debut': 'Date début',
            'date_fin': 'Date fin',
            'updated_at': 'Date de modif.',
          },
          columnsClasses: {
            action: 'pre-formatted sort-top position-r action-xs',
            'famille_produit.libelle': 'action-md',
            'created_at': 'action-xs pre-formatted',
            'updated_at': 'action-xs pre-formatted',
            'date_debut': 'action-xs pre-formatted',
            'date_fin': 'action-xs pre-formatted'
          },
          rowClassCallback(row) {
            if (row.date_fin !== null) {
              let dateFin = new Date(row.date_fin).getTime()
              let today = new Date().getTime()
              return dateFin < today ? 'desactive' : ''
            }
          },
          sortable: ['created_at', 'famille_produit.libelle'],
          filterable: ['famille_produit.libelle'],
          perPage: 10,
          perPageValues: [10, 25, 50],
          texts: {
            filterPlaceholder: "Nom"
          },
          orderBy: {column: 'famille_produit.libelle', ascending: false}
        },
        rules: espaceGestionRules,
      }
    },
    mounted() {
      this.all();
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
    },
    methods: {
      all() {
        this.$axios
          .get("/espaceGestion/consignes-produits")
          .then(response => {
            this.data = response.data.data;
          })
          .catch(() => {
            this.handleError(this);
          });
      },
      destroy(id) {
        this.$swal
          .fire({
            title: 'Êtes-vous sûr?',
            text: "Voulez-vous vraiment supprimer cette consigne ?",
            type: 'warning',
            reverseButtons: true,
            showCancelButton: true,
            cancelButtonColor: "#ff1744",
            confirmButtonText: 'Annuler',
            cancelButtonText: 'Supprimer',
          })
          .then((result) => {
            if (!result.value) {
              this.$store.commit('IS_LOADING', true)
              this.$axios
                .delete("/espaceGestion/consignes-produits/" + id)
                .then(() => {
                  this.$store.commit('IS_LOADING', false)
                  this.$swal({
                    position: 'top',
                    type: 'success',
                    title: 'Suppression avec succès',
                    text: "La consigne a bien été supprimée",
                    showConfirmButton: false,
                    timer: 5000
                  });
                  this.all();
                })
                .catch(() => {
                  this.handleError(this);
                })
            }
          })

      },
      add() {
        this.$router.push({path: '/espace-gestion/consignes-produit/add'})
      },
      edit(id) {
        this.$router.push({path: '/espace-gestion/consignes-produit/edit/' + id})
      },
      handleError(self) {
        self.$store.commit("IS_LOADING", false);
        self.$swal({
          position: 'top',
          type: 'error',
          title: 'Attention !!',
          text: 'Un problème est survenu, merci de contacter l\'administrateur',
          showConfirmButton: false,
          timer: 5000
        });
      },
      getFormattedDateTime(textDate) {
        if(textDate !== null && textDate !== ''){
          return formatDateTime(textDate, '/');
        }
      },
      getTimestamp() {
        let date = new Date;
        let day = date.getDate().toString().length === 1 ? '0' + date.getDate().toString() : date.getDate().toString();
        let month = (date.getMonth() + 1).toString().length === 1 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString();
        let year = date.getFullYear().toString();

        return day + '_' + month + '_' + year;
      },
      canExtract(rule) {
        return hasRule(rule)
      },
      downloadConsignesProduit() {
        let url = 'extract_consignes_produits'
        let filename = 'consignes_produits'
        let extension = 'csv'
        let self = this
        extension = isEmpty(extension) ? 'csv' : extension;

        this.$store.commit('IS_LOADING', true);
        this.$axios.get(`/espaceGestion/extractions/${url}`, {responseType: 'blob'})
          .then((response) => {
            this.$store.commit('IS_LOADING', false);
            downloadFile(response, filename, extension);
          })
          .catch(error => {
            self.$store.commit('IS_LOADING', false);
            let errorText = "Une erreur est survenue. Si le problème persiste, merci de faire un ticket au support DOSI."
            if (error.response.status === 403) {
              errorText = "Vous n'êtes pas autorisé à effectuer cette action"
            }
            self.$swal({
              position: "top",
              type: "error",
              title: "Attention !!",
              text: errorText,
              showConfirmButton: false,
              timer: 5000
            })
          });
      },
      formatDateHeure(textDate) {
        let date = textDate !== null ? new Date(textDate).toLocaleString("fr-FR") : "-";
        return date;
      },
      formatDate(textDate) {
        return textDate !== null ? moment(textDate).format('DD/MM/YY') : "-";
      }
    }
  }
</script>
